<template>
  <div class="ticket-evaluation">
    <evaluation
      greetings="请对本次服务评价，我们将持续优化"
      :scores="scores"
      :onSubmit="onSubmit"
    ></evaluation>
  </div>
</template>

<script>
import { getQuestionnaireFormInfo, submitQuestionnaire } from '@api/resourceApi'
import Evaluation from '../../components/evaluation/index'
import { toast } from '../../../../native'

export default {
  name: 'TicketEvaluation',
  props: ['recordId', 'ticketId'],
  components: {
    Evaluation
  },
  watch: {
    recordId(_newVal) {
      this.getEvaluationInfo()
    }
  },
  mounted() {
    this.getEvaluationInfo()
  },
  data() {
    return {
      scores: [
        {
          scoreId: '256',
          score: '1',
          options: [
            {
              name: '投诉',
              id: '112',
              status: '1'
            }
          ],
          scoreDesc: '很差'
        },
        {
          scoreId: '258',
          score: '3',
          options: [
            {
              name: '还要进步',
              id: '114',
              status: '1'
            }
          ],
          scoreDesc: '一般'
        },
        {
          scoreId: '260',
          score: '5',
          options: [
            {
              name: '加鸡腿',
              id: '116',
              status: '1'
            }
          ],
          scoreDesc: '很好'
        }
      ]
    }
  },
  methods: {
    getEvaluationInfo() {
      if (this.recordId) {
        getQuestionnaireFormInfo({ recordId: this.recordId }).then((resp) => {
          this.scores = resp.scores
        })
      }
    },
    onSubmit(data) {
      console.log('提交的数据', data)
      const params = {
        ticketId: this.ticketId,
        recordId: this.recordId,
        score: data.score,
        content: data.comment,
        optionIds: data.optionIds
      }
      submitQuestionnaire(params).then((resp) => {
        const { status, msg = '' } = resp
        if (+status === 1000) {
          toast({
            msg: '评价成功',
            style: '1'
          })
          this.$emit('evaluate-success')
        } else {
          msg &&
              toast({
                msg,
                style: '2'
              })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
